import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import { FlexDiv, WideBox } from '../../styles/styles';
import PaymentForm from '../PaymentForm';

const NewPayment = () => {
  const history = useHistory();
  const { authStore, dataStore } = useRootStore();
  const { state } = useLocation();
  const paymentFromVoucher = state
    ? (({ ContactId, Amount, Description, AccountId, VoucherTypeDesc }) => ({
        ContactId,
        Amount,
        Description,
        AccountId,
        VoucherTypeDesc,
      }))(state)
    : {};

  // maxWidth: '500px'
  return (
    <FlexDiv>
      <WideBox showoverflow={1} style={{ justifyContent: 'center' }}>
        <PaymentForm
          buttons={[
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => history.goBack()}
              size="large"
            >
              Cancel
            </Button>,
          ]}
          payment={paymentFromVoucher}
          onSubmit={async values => {
            const {
              Contact,
              ContactId,
              PaymentDate,
              DepositDate,
              ClearedDate,
              Amount,
              Description,
              StatusId,
              TypeId,
              TranType,
              IsCleared,
              AccountId,
              PaymentVouchers,
            } = values;
            try {
              const response = await authStore.request.post(
                `${process.env.REACT_APP_API}/api/payment`,
                {
                  Contact,
                  ContactId,
                  PaymentDate,
                  DepositDate,
                  ClearedDate,
                  Amount,
                  Description,
                  StatusId,
                  TypeId,
                  TranType,
                  IsCleared,
                  AccountId,
                  PaymentVouchers,
                },
              );
              await dataStore.retrieveAllPayments();
              history.push('/payments');
            } catch (e) {
              console.error(e);
            }
          }}
        />
      </WideBox>
    </FlexDiv>
  );
};

export default NewPayment;
